import React from "react";
import { Route } from "react-router-dom";
import AuthorizeRoute from "./../ApiAuthorization/AuthorizeRoute";

const routeUtils = {
  makeRoutes(routes) {
    const render = (route, i) => {
      if (route.isAuthProtected === true) {
        delete route.isAuthProtected;
        return (<AuthorizeRoute key={i} {...route} />);
      } else {
        return (<Route key={i} {...route} />);
      }
    };

    if (Array.isArray(routes)) {
      return routes.map((route, i) => render(route, i));
    } else {
      return Object.keys(routes).map((key, i) => render(routes[key], i));
    }
  }
};

export default routeUtils;
